import React from "react";

import { useAcknowledgeAlert } from "api/api-hooks/alerts-hooks";
import { AlertDTO } from "api/model/alerts/alert-types";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { StringKey } from "services/lang/keys";
import { T } from "services/lang/LanguageService";
import { timeAgo } from "utils/time-utils";

interface Props {
  alert: AlertDTO;
}

const PRIORITY_SEVERITY: Record<string, "danger" | "warning" | "info"> = {
  CRITICAL: "danger",
  WARNING: "warning",
  NOTICE: "info",
};

export default function AlertItem({ alert }: Props) {
  const { mutate: acknowledge, isPending } = useAcknowledgeAlert();

  return (
    <Card
      className={`alert-item ${alert.isAcknowledged ? "acknowledged" : ""}`}
      style={{ opacity: alert.isAcknowledged ? 0.7 : 1 }}
    >
      <div className="flex justify-content-between align-items-start mb-2">
        <Tag
          value={T(`alert.${alert.priority.toLowerCase()}` as StringKey)}
          severity={PRIORITY_SEVERITY[alert.priority]}
        />
        <span className="text-xs text-500">{timeAgo(alert.createdAt)}</span>
      </div>

      <div
        className="m-0 mb-2 alert-message-content"
        dangerouslySetInnerHTML={{ __html: alert.message || alert.shortMessage || "Message not found" }}
      />

      {!alert.isAcknowledged && (
        <Button
          label={T("word.acknowledge")}
          icon="pi pi-check"
          size="small"
          onClick={() => acknowledge(alert.id)}
          loading={isPending}
        />
      )}
    </Card>
  );
}
